import { render } from "./MMEditMembersResources.vue?vue&type=template&id=d3a39f5a"
import script from "./MMEditMembersResources.vue?vue&type=script&lang=js"
export * from "./MMEditMembersResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__